import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const steps = [{
  n: '1',
  title: 'Get your Reader-to-Revenue Score',
  lines: ['8 questions to see how clearly reader interest connects to your business.']
}, {
  n: '2',
  title: 'Audit the reader path',
  lines: ['We review the gaps between your book, the reader path, and your offers — and whether a build is warranted.']
}, {
  n: '3',
  title: 'Decide whether to build',
  lines: ['No pressure.', 'Decide once the opportunity is clear.']
}];
export function ScoreAuditBuild() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paperDark" width="default" data-id="element-1041" data-mp="2cfmt19f6e5g2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-1042" data-mp="2cgxv94sz3552">
        <Reveal data-id="element-1043" data-mp="15zsveh61tny7">
          <Eyebrow data-id="element-1044" data-mp="160cew2bckkec">How it works</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-1045" data-mp="10zodcmphsl5v">
            Get the score before you
            <br data-id="element-1046" data-mp="18gqlkg8vxye6" />
            <span className="italic text-seaglass" data-id="element-1047" data-mp="18ibgw830xld3">decide what to build.</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} data-id="element-1048" data-mp="1chsmr2md4kis">
        <div className="mt-14 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-1049" data-mp="yisz9yal6bo7">
          {steps.map(step => <div key={step.n} className="relative rounded-3xl border border-gray-200 bg-white p-7 text-center" data-id="element-1050" data-mp="ykx3yigb7epj">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-seaglass font-serif text-xl text-white" data-id="element-1051" data-mp="ot116u3a30ez">
                {step.n}
              </div>
              <h3 className="mt-5 font-serif text-xl text-navy" data-id="element-1052" data-mp="tlu6pk6kmcs4">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-text-muted" data-id="element-1053" data-mp="ftw13jc2iz0p">
                {step.lines.map(line => <span key={line} className="block" data-id="element-1054" data-mp="krnvck06qx82">
                    {line}
                  </span>)}
              </p>
            </div>)}
        </div>
      </Reveal>

      <Reveal delay={0.15} data-id="element-1055" data-mp="as6q23ouilcm">
        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-1056" data-mp="asgidxxd54lh">
          <Cta variant="primary" size="lg" showArrow onClick={openDiagnostic} data-id="element-1057" data-mp="3nu99pdpegz4a">
            Get Your Reader-to-Revenue Score
          </Cta>
          <p className="text-center text-base font-medium text-text-muted" data-id="element-1058" data-mp="3j1zhfr0tbmyu">
            <span className="block" data-id="element-1059" data-mp="3e4zfnsazx6dj">Start with the Score.</span>
            <span className="block" data-id="element-1060" data-mp="395ms15cavv9w">The rest follows only if it fits.</span>
          </p>
        </div>
      </Reveal>
    </SectionBand>;
}